// extracted by mini-css-extract-plugin
export var backgroundImage = "SectionText-module--backgroundImage--ICoLl";
export var hasBackground = "SectionText-module--hasBackground--agu0p";
export var richtext = "SectionText-module--richtext--7Vexl";
export var section = "SectionText-module--section--+NgU7";